export default "__VITE_ASSET__CufVRnbu__$_?format=webp__"